import EXPERIMENTS from './experiments';

// We use `PUSHTELL-` prefix for `localStorage` to make it backward compatible.
export const STORAGE_KEY_PREFIX = 'PUSHTELL-';

export const getLocalStorageKeyForExperiment = (experimentName: string) => `${STORAGE_KEY_PREFIX}${experimentName}`;

export const getAllVariantsFromLocalStorage = () => {
  const entries = Object.values(EXPERIMENTS)
    .map(({ name }) => [name, window.localStorage.getItem(getLocalStorageKeyForExperiment(name))])
    .filter(([, value]) => !!value);
  return entries.length ? (Object.fromEntries(entries) as Record<string, string>) : undefined;
};
